import { API_V4 } from "@/services/config/auth-axios";

class TransferService {
  getUserAgreement() {
    return API_V4.get("/market/transfers/user-agreement", {});
  }

  transferToMarket(data) {
    return API_V4.post(`/orders/transfer/market`, data);
  }
}
export default new TransferService();
